export const classes = {
  row: 'flex w-full gap-3 mb-1 rounded-xl bg-transparent px-3 py-3 shadow-none transition-colors hover:bg-black/5 dark:hover:bg-white/5',
  cardRow:
    'flex w-full cursor-pointer items-center gap-[13px] mb-[11px] rounded-2xl border border-black/10 bg-white/[0.82] px-4 py-[13px] shadow-aurora-card transition hover:border-brand-accent/55 hover:shadow-row-hover dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  icon: 'size-10 shrink-0',
  content: 'min-w-0 grow',
  titleWrapper: 'place-between gap-4',
  titleWrapperWide: 'justify-start gap-2 flex-wrap',
  title:
    'text-start text-sm font-semibold text-taupe-3 hover:underline cursor-pointer outline-none dark:text-mauve-1',
  chipsWrapper: 'flex items-center gap-2 shrink-0',
  chip: 'shrink-0',
  description: 'text-xs text-taupe-2 mt-1 dark:text-mauve-2',
};
